import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6e5ceb6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "embed-actions" }
const _hoisted_2 = { class: "embed-settings" }
const _hoisted_3 = { class: "subtitle subtitle-general" }
const _hoisted_4 = { class: "inputs" }
const _hoisted_5 = { class: "inputs" }
const _hoisted_6 = { class: "inputs" }
const _hoisted_7 = { class: "inputs" }
const _hoisted_8 = { class: "subtitle" }
const _hoisted_9 = { class: "subtitle" }
const _hoisted_10 = { class: "field-actions" }

import {ref} from "vue";
import TemplateInput from "@/components/TemplateInput.vue";
import {Embed, EmbedTimestamp} from "@/types/Embed";
import i18n from "@/plugins/i18n";
import TimestampInput from "@/components/TimestampInput.vue";
import {TemplateVariable} from "@/types/TemplateVariable";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmbedInput',
  props: /*#__PURE__*/_mergeModels({
    modelValue: {},
    disabled: { type: Boolean },
    variables: {}
  }, {
    "modelValue": {default: {enabled: false}},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props
let embed = _useModel<Embed>(__props, "modelValue")
let dialog = ref(false)
let valid = ref(true)
let colorPicker = ref(false)
let fieldRemove = ref(false)

function lengthRules(length: number) {
  return [(str: string) => (str.length <= length || i18n.global.t('EmbedInput.errors.invalidLength')
      .replace("[length]", String(length)))]
}

const fieldNameRules = [
  (name: string) => (name.length > 0 || i18n.global.t('EmbedInput.errors.nameRequired')),
  (name: string) => (name.length <= 256 || i18n.global.t('EmbedInput.errors.invalidLength').replace("[length]", "256"))
]

if (!embed?.value?.enabled) embed.value = {
  enabled: false,
  color: '#00a6ff',
  author: {name: '', url: '', iconUrl: ''},
  title: '', url: '',
  description: '',
  fields: [],
  image: '', thumbnail: '',
  footer: {text: '', iconUrl: ''},
  timestamp: {type: null, date: new Date(), template: "{{member.created}}"} as EmbedTimestamp
}

function addField() {
  embed.value!.fields!.push({name: '', value: '', inline: false})
}

function submit() {
  embed.value!.fields!.filter(f => !f.name.trim().length || !f.value.trim().length)
      .map(f => embed.value!.fields!.splice(embed.value?.fields?.indexOf(f), 1))
  dialog.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        color: "primary",
        disabled: props.disabled || !_unref(embed).enabled,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = true : dialog = true))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('EmbedInput.title')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_v_switch, {
        modelValue: _unref(embed).enabled,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(embed).enabled) = $event)),
        class: "embed-switch",
        color: "primary",
        "hide-details": "",
        disabled: props.disabled
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(dialog),
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : dialog = $event)),
      fullscreen: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { color: "modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar, {
              dark: "",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  icon: "close",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = false : dialog = false))
                }),
                _createVNode(_component_v_toolbar_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('EmbedInput.title')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_toolbar_items, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      dark: "",
                      disabled: _unref(valid) === false,
                      onClick: submit
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "btn-icon",
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("check")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('EmbedInput.done')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_form, {
                modelValue: _unref(valid),
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(valid) ? (valid).value = $event : valid = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('EmbedInput.general')), 1),
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    width: "500px",
                    "open-on-click": ""
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        class: "general-icon",
                        icon: "help_outline",
                        variant: "text",
                        density: "comfortable"
                      }, props), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('EmbedInput.generalDescription')) + " ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_text_field, {
                    modelValue: _unref(embed).color,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(embed).color) = $event)),
                    class: "input",
                    label: _ctx.$t('EmbedInput.embed.color'),
                    readonly: ""
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: _unref(embed).color,
                        icon: "$vuetify"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("palette")
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_overlay, {
                        modelValue: _unref(colorPicker),
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(colorPicker) ? (colorPicker).value = $event : colorPicker = $event)),
                        activator: "parent",
                        scrim: false,
                        "location-strategy": "connected",
                        "scroll-strategy": "reposition"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_color_picker, {
                            modelValue: _unref(embed).color,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(embed).color) = $event)),
                            mode: "hex",
                            modes: ['hex', 'rgb', 'hsl']
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label"]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(embed).author.name,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(embed).author.name) = $event)),
                      class: "input",
                      label: _ctx.$t('EmbedInput.embed.author.name'),
                      color: "primary",
                      "prepend-icon": "person",
                      counter: 256,
                      rules: lengthRules(256)
                    }, null, 8, ["modelValue", "label", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(embed).author.url,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(embed).author.url) = $event)),
                      class: "input",
                      label: _ctx.$t('EmbedInput.embed.author.url'),
                      color: "primary",
                      "prepend-icon": "link",
                      counter: 2048,
                      rules: lengthRules(2048)
                    }, null, 8, ["modelValue", "label", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(embed).author.iconUrl,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(embed).author.iconUrl) = $event)),
                      class: "input",
                      label: _ctx.$t('EmbedInput.embed.author.iconUrl'),
                      color: "primary",
                      "prepend-icon": "account_circle",
                      counter: 2048,
                      rules: lengthRules(2048)
                    }, null, 8, ["modelValue", "label", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(embed).title,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(embed).title) = $event)),
                      class: "input",
                      label: _ctx.$t('EmbedInput.embed.title'),
                      color: "primary",
                      "prepend-icon": "title",
                      counter: 256,
                      rules: lengthRules(256)
                    }, null, 8, ["modelValue", "label", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(embed).url,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(embed).url) = $event)),
                      class: "input",
                      label: _ctx.$t('EmbedInput.embed.url'),
                      color: "primary",
                      "prepend-icon": "link",
                      counter: 2048,
                      rules: lengthRules(2048)
                    }, null, 8, ["modelValue", "label", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(embed).image,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(embed).image) = $event)),
                      class: "input",
                      label: _ctx.$t('EmbedInput.embed.image'),
                      color: "primary",
                      "prepend-icon": "image",
                      counter: 2048,
                      rules: lengthRules(2048)
                    }, null, 8, ["modelValue", "label", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(embed).thumbnail,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(embed).thumbnail) = $event)),
                      class: "input",
                      label: _ctx.$t('EmbedInput.embed.thumbnail'),
                      color: "primary",
                      "prepend-icon": "art_track",
                      counter: 2048,
                      rules: lengthRules(2048)
                    }, null, 8, ["modelValue", "label", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(embed).footer.text,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(embed).footer.text) = $event)),
                      class: "input",
                      label: _ctx.$t('EmbedInput.embed.footer.text'),
                      color: "primary",
                      "prepend-icon": "edit_note",
                      counter: 2048,
                      rules: lengthRules(2048)
                    }, null, 8, ["modelValue", "label", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(embed).footer.iconUrl,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(embed).footer.iconUrl) = $event)),
                      class: "input",
                      label: _ctx.$t('EmbedInput.embed.footer.iconUrl'),
                      color: "primary",
                      "prepend-icon": "link",
                      counter: 2048,
                      rules: lengthRules(2048)
                    }, null, 8, ["modelValue", "label", "rules"])
                  ]),
                  _createVNode(TimestampInput, {
                    modelValue: _unref(embed).timestamp,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(embed).timestamp) = $event)),
                    variables: _ctx.variables ?? ['member', 'guild']
                  }, null, 8, ["modelValue", "variables"]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('EmbedInput.description')), 1),
                  _createVNode(TemplateInput, {
                    modelValue: _unref(embed).description,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(embed).description) = $event)),
                    variables: _ctx.variables ?? ['member', 'guild'],
                    counter: 2048
                  }, null, 8, ["modelValue", "variables"]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('EmbedInput.fields')), 1),
                  (_unref(embed).fields.length)
                    ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                        key: 0,
                        class: "fields",
                        variant: "accordion",
                        multiple: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(embed).fields, (field, i) => {
                            return (_openBlock(), _createBlock(_component_v_expansion_panel, { "bg-color": "block" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_expansion_panel_title, {
                                  class: "field-number",
                                  ripple: !_unref(fieldRemove),
                                  readonly: _unref(fieldRemove)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('EmbedInput.field')) + " " + _toDisplayString(i + 1), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["ripple", "readonly"]),
                                _createVNode(_component_v_expansion_panel_text, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: field.name,
                                      "onUpdate:modelValue": ($event: any) => ((field.name) = $event),
                                      class: "field-name",
                                      label: _ctx.$t('EmbedInput.embed.field.name'),
                                      color: "primary",
                                      counter: 256,
                                      rules: fieldNameRules
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
                                    _createVNode(TemplateInput, {
                                      modelValue: field.value,
                                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                      variables: _ctx.variables ?? ['member', 'guild'],
                                      counter: 1024,
                                      required: "",
                                      label: _ctx.$t('EmbedInput.embed.field.value')
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "variables", "label"]),
                                    _createElementVNode("div", _hoisted_10, [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: field.inline,
                                        "onUpdate:modelValue": ($event: any) => ((field.inline) = $event),
                                        color: "primary",
                                        label: _ctx.$t('EmbedInput.embed.field.inline'),
                                        density: "comfortable",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
                                      _createVNode(_component_v_btn, {
                                        icon: "delete",
                                        variant: "text",
                                        color: "red",
                                        size: "x-large",
                                        density: "comfortable",
                                        onClick: ($event: any) => (_unref(embed).fields.splice(i, 1))
                                      }, null, 8, ["onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(embed).fields.length < 25)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        icon: "add",
                        variant: "tonal",
                        color: "primary",
                        onClick: addField
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})